// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"368":"3c847955","694":"ddebc681","887":"673d9a6f","990":"c1385146"}[chunkId] + ".css";
};